    export var AlertsConfig = {
        "App_AcceptNoticeMap_Alert": {
            "options": {
                "message": 'Veuillez accepter les conditions d\'utilisation ci-dessus, puis cliquez sur <strong>Carte</strong> pour accéder à l\'application.',
                "date": false,
                "classes": ["IntroModal_alert"]
            },
            "settings": {
                "type": "danger"
            }
        },
        "App_AcceptNoticeAtlas_Alert": {
            "options": {
                "message": 'Veuillez accepter les conditions d\'utilisation ci-dessus, puis cliquez sur <strong>Atlas</strong> pour accéder à l\'application.',
                "date": false,
                "classes": ["IntroModal_alert"]
            },
            "settings": {
                "type": "danger"
            }
        },
        "AuthSession_LogoutWarning" : {
            "options" : {
                "message" : "Attention",
                "date" : false
            },
            "settings" : {
                "type" : "warning",
            }
        },
        "AuthSession_LoginError" : {
            "options" : {
                "message" : "{{error}}",
                "classes": ["show"]
            },
            "settings" : {
                "type" : "danger",
            }
        },
        "AuthSession_TokenExpired" : {
            "options" : {
                "message" : "Le temps de session est écoulé. Veuillez vous authentifier de nouveau.",
                "classes": ["show"]
            },
            "settings" : {
                "type" : "info",
            }
        },
        "AuthSession_MissingUsernameInput" : {
            "options" : {
                "message" : "Veuillez entrer le nom d'utilisateur.",
                "date" : false,
                "classes": ["show"]
            },
            "settings" : {
                "type" : "danger",
            }
        },
        "AuthSession_MissingPasswordInput" : {
            "options" : {
                "message" : "Veuillez entrer le mot de passe.",
                "date" : false,
                "classes": ["show"]
            },
            "settings" : {
                "type" : "danger",
            }
        },
        "AuthSession_WrongUserLoggedIn" : {
            "options" : {
                "message" : "Cet utilisateur n'a pas accès à cette application.",
                "classes": ["show"]
            },
            "settings" : {
                "type" : "danger",
            }
        },
        "BbGraphs_bottomPanel_alert": {
            "options": {
                "message": 'Utiliser les outils de sélections (' +
                            '<span class="cv-icon-selection cv-icon"></span>' +
                            '<span class="cv-icon-circularSelection cv-icon"></span>' +
                            '<span class="cv-icon-rectangularSelection cv-icon"></span>' +
                            '<span class="cv-icon-polygonalSelection cv-icon"></span>' +
                            ') à partir de la barre d\'outils de la carte pour sélectionner des entités et afficher leurs données dans un diagramme.' +
                            ' Noter que vous pouvez également sélectionner des entités à partir du tableau de données ou de la légende.',
                "date": false,
                "classes": ["Alerts_show"]
            },
            "settings": {
                "type": "info",
            }
        },
        "ContactUs_mapTargetNotCreated" : {
            "options" : {
                "message" : "Activez l'outil cible, puis clicquez sur la carte à l'emplacement réel de l'école sélectionnée."
            },
            "settings" : {
                "type" : "danger",
            }
        },
        "ContactUs_checkboxNotCheked" : {
            "options" : {
                "message" : "Veuillez spécifier si l'incohérence à envoyée est sur la localisation ou sur les infomations descriptives de l'école."
            },
            "settings" : {
                "type" : "danger",
            }
        },
        "ContactUs_serviceError" : {
            "options" : {
                "message" : "{{error}}"
            },
            "settings" : {
                "type" : "danger",
                "onShow" : function(alertParams) { $.notifyClose(); }
            }
        },
        "ContactUs_serviceSuccess" : {
            "options" : {
                "message" : "Votre message a été envoyé avec succès."
            },
            "settings" : {
                "type" : "success",
                "onShow" : function(alertParams) { $.notifyClose(); }
            }
        },
        "ContactUs_formIsSubmitting" : {
            "options" : {
                "message" : "Une requête est déjà en cours. Veuillez attendre qu'elle soit complétée."
            },
            "settings" : {
                "type" : "danger",
            }
        },
        "ContactUs_requestSubmitted" : {
            "options" : {
                "message" : "Veuillez patienter..."
            },
            "settings" : {
                "type" : "info",
                "delay" : 0
            }
        },
        "DecoupagePanel_AddSectorModalWarning" : {
            "options" : {
                "message" : "Attention",
                "date" : false
            },
            "settings" : {
                "type" : "warning"
            }
        },
        "DecoupagePanel_SectorFusionWarning" : {
            "options" : {
                "message" : "Attention",
                "date" : false
            },
            "settings" : {
                "type" : "warning"
            }
        },
        "DecoupagePanel_DeleteSectorError_1" : {
            "options" : {
                "message" : "Opération annulée: veuillez d'abord sélectionner un {{title}}.",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "DecoupagePanel_DeleteSectorError_2" : {
            "options" : {
                "message" : "Opération annulée: le {{title}} doit être vide de tout {{point}} pour être supprimé.",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "DecoupagePanel_AddSectorError_1" : {
            "options" : {
                "message" : "Opération annulée: le code du {{title}} ne doit pas être nul ni avoir plus de deux caractères alphanumériques.",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "DecoupagePanel_AddSectorError_2" : {
            "options" : {
                "message" : "Opération annulée: le code du groupe ne doit pas être nul ni avoir plus de deux caractères alphanumériques.",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "DecoupagePanel_AddSectorError_3" : {
            "options" : {
                "message" : "Opération annulée: <strong>le {{title}} {{sectorCode}}</strong> existe déjà pour le <strong>{{scenario}}</strong>.",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "DecoupagePanel_CodeSectorChangeError" : {
            "options" : {
                "message" : "Opération annulée: le code du {{title}} ne doit pas être nul ni avoir plus de deux caractères alphanumériques.",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "DescriptionPanel_AddAlertSuccess" : {
            "options" : {
                "message" : '<span style="line-height:25px;">Cette description est correctement sauvegardée.</span>',
                "date" : false
            },
            "settings" : {
                "type" : "success"
            }
        },
        "DescriptionPanel_AddAlertWarning" : {
            "options" : {
                "message" : "<span style=\"line-height:25px;\">Les modifications n\'ont pas été sauvegardées. Veuillez cliquer sur le bouton <strong>Sauvegarder</strong> lorsque vous aurez terminé d'éditer la description.</span><button id=\"DescriptionPanel_submitBtn\" type=\"button\" class=\"btn btn-primary btn-sm float-end editionAllowed\">Sauvegarder</button>",
                "date" : false
            },
            "settings" : {
                "type" : "warning"
            }
        },
        "DownloadShapefileTool_layerHasNoFeature" : {
            "options" : {
                "message" : "Opération annulée: aucune entitée n'est présente dans la couche <strong>{{layerName}}</strong>.",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "DownloadShapefileTool_layerHasNoFeatureScenario" : {
            "options" : {
                "message" : "Opération annulée: aucune entitée n'est présente dans la couche <strong>{{layerName}}</strong> pour le <strong>{{scenario}}</strong>.",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "DrawingControllerExtend_ChangingDrawingModeError" : {
            "options" : {
                "message" : "Opération annulée: veuillez attendre que le dessin soit correctement sauvegardé.",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "DrawingControllerExtend_LineSaved" : {
            "options" : {
                "message" : "Opération réussie: <strong>la limite</strong> a été sauvegardée.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "DrawingControllerExtend_LinesSaved" : {
            "options" : {
                "message" : "Opération réussie: <strong>les {{count}} limites</strong> ont été sauvegardées.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "DrawingControllerExtend_AnnotationSaved" : {
            "options" : {
                "message" : "Opération réussie: <strong>l'annotation</strong> a été sauvegardée.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "DrawingControllerExtend_AnnotationsSaved" : {
            "options" : {
                "message" : "Opération réussie: <strong>les {{count}} annotations</strong> ont été sauvegardées.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "DrawingControllerExtend_LineDeleted" : {
            "options" : {
                "message" : "Opération réussie: <strong>la limite</strong> a été supprimée.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "DrawingControllerExtend_LinesDeleted" : {
            "options" : {
                "message" : "Opération réussie: <strong>les {{count}} limites</strong> ont été supprimées.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "DrawingControllerExtend_AnnotationDeleted" : {
            "options" : {
                "message" : "Opération réussie: <strong>l'annotation</strong> a été supprimée.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "DrawingControllerExtend_AnnotationsDeleted" : {
            "options" : {
                "message" : "Opération réussie: <strong>les {{count}} annotations</strong> ont été supprimées.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "FindRoutes_startMapTargetNotCreated" : {
            "options" : {
                "message" : "Activez l'outil cible, puis clicquez sur la carte à l'emplacement voulu afin de définir le point de départ."
            },
            "settings" : {
                "type" : "danger",
            }
        },
        "FindRoutes_endMapTargetNotCreated" : {
            "options" : {
                "message" : "Activez l'outil cible, puis clicquez sur la carte à l'emplacement voulu afin de définir le point d'arrivée."
            },
            "settings" : {
                "type" : "danger",
            }
        },
        "FindRoutes_noPointFeaturesSelected" : {
            "options" : {
                "message" : "Veuillez d\'abord sélectionner deux entités ponctuelles (points) dans la carte à l'aide des outils de sélection afin de définir le point de départ et le point d'arrivée."
            },
            "settings" : {
                "type" : "danger",
            }
        },
        "FindRoutes_needOnePointFeatureSelected" : {
            "options" : {
                "message" : "Veuillez d\'abord sélectionner une seule entité ponctuelle (point) dans la carte à l'aide des outils de sélection."
            },
            "settings" : {
                "type" : "danger",
            }
        },
        "FindRoutes_formIsSubmitting" : {
            "options" : {
                "message" : "Une requête est déjà en cours. Veuillez attendre qu'elle soit complétée."
            },
            "settings" : {
                "type" : "danger",
            }
        },
        "FindRoutes_over2SelectedFeaturesWarning" : {
            "options" : {
                "message" : "Notez que <strong>le nombre maximal de sources est de 2</strong>. Seules les 2 premières sources seront utilisées dans la requête."
            },
            "settings" : {
                "type" : "warning",
            }
        },
        "FindRoutes_requestSubmitted" : {
            "options" : {
                "message" : "Calcul en cours, veuillez patienter..."
            },
            "settings" : {
                "type" : "info",
                "delay" : 0
            }
        },
        "FindRoutes_serviceError" : {
            "options" : {
                "message" : "{{error}}"
            },
            "settings" : {
                "type" : "danger",
                "onShow" : function(alertParams) { $.notifyClose(); }
            }
        },
        "FindRoutes_serviceSuccess" : {
            "options" : {
                "message" : "La requête a été complétée avec succès."
            },
            "settings" : {
                "type" : "success",
                "onShow" : function(alertParams) { $.notifyClose(); }
            }
        },
        "ReloadDataTool_ErrorDrawingMode" : {
            "options" : {
                "message" : "Veuillez quitter le <strong>mode dessin</strong> avant d'actualiser les données."
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "ReloadDataTool_ReloadStarted" : {
            "options" : {
                "message" : "Veuillez patienter pendant le chargement des données...",
            },
            "settings" : {
                "type" : "info",
                "showProgressbar" : true,
                "delay" : 0
            }
        },
        "ReloadDataTool_ReloadCompleted" : {
            "options" : {
                "message" : "Les données ont été chargées correctement.",
            },
            "settings" : {
                "type" : "success",
                "onShow" : function() { $.notifyClose(); }
            }
        },
        "SectorsDatastore_SectorDataUpdated" : {
            "options" : {
                "message" : "Opération réussie: <strong>le {{title}} {{sectorCodes}}</strong> du <strong>{{scenario}}</strong> a été mis à jour.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "SectorsDatastore_SectorsDataUpdated" : {
            "options" : {
                "message" : "Opération réussie: <strong>les {{title}} {{sectorCodes}}</strong> du <strong>{{scenario}}</strong> ont été mis à jour.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "SectorsDatastore_SectorDataAdded" : {
            "options" : {
                "message" : "Opération réussie: <strong>le {{title}} {{sectorCodes}}</strong> a été ajouté au <strong>{{scenario}}</strong>.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "SectorsDatastore_SectorsDataAdded" : {
            "options" : {
                "message" : "Opération réussie: <strong>les {{title}} {{sectorCodes}}</strong> ont été ajoutés au <strong>{{scenario}}</strong>.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "SectorsDatastore_SectorDataDeleted" : {
            "options" : {
                "message" : "Opération réussie: <strong>le {{title}} {{sectorCodes}}</strong> a été supprimé du <strong>{{scenario}}</strong>.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "SectorsDatastore_SectorsDataDeleted" : {
            "options" : {
                "message" : "Opération réussie: <strong>les {{title}} {{sectorCodes}}</strong> ont été supprimés du <strong>{{scenario}}</strong>.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "ServerRequests_ServiceError" : {
            "options" : {
                "message" : "{{error}}",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "ServiceAreas_mapTargetNotCreated" : {
            "options" : {
                "message" : "Activez l'outil cible, puis clicquez sur la carte à l'emplacement voulu."
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "ServiceAreas_noPointFeaturesSelected" : {
            "options" : {
                "message" : "Veuillez d\'abord sélectionner des entités ponctuelles (points) dans la carte à l'aide des outils de sélection."
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "ServiceAreas_formIsSubmitting" : {
            "options" : {
                "message" : "Une requête est déjà en cours. Veuillez attendre qu'elle soit complétée."
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "ServiceAreas_over5BreakValuesWarning" : {
            "options" : {
                "message" : "Notez que <strong>le nombre maximal de bornes est de 5</strong>. Seules les 5 premières valeurs seront utilisées dans la requête."
            },
            "settings" : {
                "type" : "warning"
            }
        },
        "ServiceAreas_over3SelectedFeaturesWarning" : {
            "options" : {
                "message" : "Notez que <strong>le nombre maximal de sources est de 3</strong>. Seules les 3 premières sources seront utilisées dans la requête."
            },
            "settings" : {
                "type" : "warning"
            }
        },
        "ServiceAreas_noOrInvalidBreakValues" : {
            "options" : {
                "message" : "Veuillez spécifier des valeurs de bornes valides."
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "ServiceAreas_requestSubmitted" : {
            "options" : {
                "message" : "Calcul en cours, veuillez patienter..."
            },
            "settings" : {
                "type" : "info",
                "delay" : 0
            }
        },
        "ServiceAreas_serviceError" : {
            "options" : {
                "message" : "{{error}}"
            },
            "settings" : {
                "type" : "danger",
                "onShow" : function(alertParams) { $.notifyClose(); }
            }
        },
        "ServiceAreas_serviceSuccess" : {
            "options" : {
                "message" : "La requête a été complétée avec succès."
            },
            "settings" : {
                "type" : "success",
                "onShow" : function(alertParams) { $.notifyClose(); }
            }
        },
        "TransferTool_TransferError_1" : {
            "options" : {
                "message" : "Opération annulée: veuillez devez d'abord sélectionner un {{title}}.",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "TransferTool_TransferError_2" : {
            "options" : {
                "message" : "Opération annulée: veuillez d'abord sélectionner le(s) point(s) d'{{title}}(s) à transférer.",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "TransferTool_CancelTransferError" : {
            "options" : {
                "message" : "Opération annulée: le {{title}} n'existe plus.",
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "TransferTool_ValidatePointRemoved" : {
            "options" : {
                "message" : "Attention: <strong>{{count}} point d'{{point}}</strong> n'a pu être transféré, car il appartient déjà au <strong>{{title}} {{sectorCode}}</strong>.",
            },
            "settings" : {
                "type" : "warning"
            }
        },
        "TransferTool_ValidatePointsRemoved" : {
            "options" : {
                "message" : "Attention: <strong>{{count}} points d'{{point}}</strong> n'ont pu être transférés, car ils appartiennent déjà au <strong>{{title}} {{sectorCode}}</strong>.",
            },
            "settings" : {
                "type" : "warning"
            }
        },
        "TransferTool_ValidatePointRemovedExt" : {
            "options" : {
                "message" : "Attention: <strong>{{count}} point d'{{point}}</strong> n'a pu être transféré, car il appartient au <strong>{{title}} {{sectorCode}}</strong>.",
            },
            "settings" : {
                "type" : "warning"
            }
        },
        "TransferTool_ValidatePointsRemovedExt" : {
            "options" : {
                "message" : "Attention: <strong>{{count}} points d'{{point}}</strong> n'ont pu être transférés, car ils appartiennent au <strong>{{title}} {{sectorCode}}</strong>.",
            },
            "settings" : {
                "type" : "warning"
            }
        },
        "TransferTool_PointUpdated" : {
            "options" : {
                "message" : "Opération réussie: <strong>{{count}} point</strong> pour un total de <strong>{{sum}} {{point}}(s)</strong> transféré(s) dans le <strong>{{title}} {{sectorCode}}</strong>.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "TransferTool_PointsUpdated" : {
            "options" : {
                "message" : "Opération réussie: <strong>{{count}} points</strong> pour un total de <strong>{{sum}} {{point}}s</strong> transférés dans le <strong>{{title}} {{sectorCode}}</strong>.",
            },
            "settings" : {
                "type" : "success"
            }
        },
        "QueryCpAdrs_QueryData" : {
            "options" : {
                "message" : "Veuillez patienter pendant le chargement des données..."
            },
            "settings" : {
                "type" : "info",
                "delay" : 0
            }
        },
        "QueryCpAdrs_SelectByValuesInputEmpty" : {
            "options" : {
                "message" : "La requête est invalide - aucune valeur n'est entrée."
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "QueryCpAdrs_formIsSubmitting" : {
            "options" : {
                "message" : "Une requête est déjà en cours. Veuillez attendre qu'elle soit complétée."
            },
            "settings" : {
                "type" : "danger"
            }
        },
        "QueryCpAdrs_QueryNotFound" : {
            "options" : {
                "message" : "La requête n'a retourné aucun résultat."
            },
            "settings" : {
                "type" : "danger",
                "onShow" : function(alertParams) { $.notifyClose(); }
            }
        },
        "QueryCpAdrs_QueryError" : {
            "options" : {
                "message" : "La requête n'a pas pu être complétée."
            },
            "settings" : {
                "type" : "danger",
                "onShow" : function(alertParams) { $.notifyClose(); }
            }
        },
        "QueryCpAdrs_ServerDataInitialized" : {
            "options" : {
                "message" : "Les données de la requête ont été chargées correctement."
            },
            "settings" : {
                "type" : "success",
                "onShow" : function(alertParams) { $.notifyClose(); }
            }
        }
    };